import React  from "react"
import { getAssetById } from "../../../../shared/selectors/asset"
import { IFormAsset } from "../../../assets/state/assetsTypes"
import CasePdfViewer from "./CasePdfViewer"
import CaseFormIframeViewer from "./CaseFormIframeViewer"
import { useAppSelector } from "../../../../shared/hooks"

interface IProps {
  assetId: string
}

const CaseFormViewer: React.FC<IProps> = (props): JSX.Element => {
  const asset = useAppSelector((state) => getAssetById(state, props))
  const form = asset.asset as IFormAsset

  if (form.path) {
    return(
      <CasePdfViewer {...props}/>
    )
  }

  return (
    <CaseFormIframeViewer {...props}/>
  )
}

export default CaseFormViewer
